var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvertencia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.28 245.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #aaf7c0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.52,201.22s-3.33,23.45,5.14,44.33c0,0-32.68-4.84-53.1-32.23l47.96-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m110.14,220.28c14.87,0,29.29-2.91,42.87-8.66,13.12-5.55,24.89-13.49,35.01-23.6,10.11-10.11,18.05-21.89,23.6-35.01,5.75-13.58,8.66-28.01,8.66-42.87s-2.91-29.29-8.66-42.87c-5.55-13.12-13.49-24.89-23.6-35.01-10.11-10.11-21.89-18.05-35.01-23.6C139.43,2.91,125.01,0,110.14,0s-29.29,2.91-42.87,8.66c-13.12,5.55-24.89,13.49-35.01,23.6-10.11,10.11-18.05,21.89-23.6,35.01C2.91,80.85,0,95.28,0,110.14s2.91,29.29,8.66,42.87c5.55,13.12,13.49,24.89,23.6,35.01,10.11,10.11,21.89,18.05,35.01,23.6,13.58,5.75,28.01,8.66,42.87,8.66Zm0-205.15c12.83,0,25.27,2.51,36.98,7.46,11.31,4.78,21.47,11.64,30.2,20.36,8.73,8.73,15.58,18.89,20.36,30.2,4.95,11.71,7.46,24.15,7.46,36.98s-2.51,25.27-7.46,36.98c-4.78,11.31-11.64,21.47-20.36,30.2-8.73,8.73-18.89,15.58-30.2,20.36-11.71,4.95-24.15,7.46-36.98,7.46s-25.27-2.51-36.98-7.46c-11.31-4.78-21.47-11.64-30.2-20.36-8.73-8.73-15.58-18.89-20.36-30.2-4.95-11.71-7.46-24.15-7.46-36.98s2.51-25.27,7.46-36.98c4.78-11.31,11.64-21.47,20.36-30.2,8.73-8.73,18.89-15.58,30.2-20.36,11.71-4.95,24.15-7.46,36.98-7.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.71 140.12 120.73 49.69 99.55 49.69 102.58 140.12 117.71 140.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.24,
    y: 152.78,
    width: 17.81,
    height: 17.81,
    transform: "translate(220.28 323.37) rotate(180)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertencia);
export default __webpack_public_path__ + "static/media/ADVERTENCIA.ef37016f85bec1025f8d0c81c6348168.svg";
export { ForwardRef as ReactComponent };